import axios, { AxiosResponse } from 'axios';
import { environment } from '../../../config/env';
import { CardLinkPayload, CardLinkResponse } from './modals';
const API_URL = environment.API_URL;
const GET_VIEW_CARD_URL = `${API_URL}/card/card-link`;

export const getViewCardLink = async (payload: CardLinkPayload) => {
  return axios.post(GET_VIEW_CARD_URL, payload).then((response: AxiosResponse<CardLinkResponse>) => response.data);
};
